import { Skeleton } from '@/_components';

function MetricCardSkeleton() {
  return (
    <div className="border-c-border-muted flex min-h-36 flex-col gap-3 rounded-xl border bg-white p-4 dark:bg-gray-800">
      <div className="flex items-center gap-2">
        <Skeleton className="h-5 w-5" />
        <Skeleton className="h-4 w-24" />
      </div>

      <Skeleton className="h-8 w-1/2" />

      <Skeleton className="h-3 w-full" />
    </div>
  );
}

export function WidgetMetricCardLoading() {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      {Array.from({ length: 4 }).map((_, index) => (
        <MetricCardSkeleton key={index} />
      ))}
    </div>
  );
}
